// extracted by mini-css-extract-plugin
export default {"mail_content":"style__mail_content__A2TpU","error_info":"style__error_info__rrFER","error":"style__error__TCl4d","save_succ":"style__save_succ__mZqv5"};